import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SitePreview from '../components/SitePreview';
import { Loader2, Eye, ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PreviewPage() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [siteData, setSiteData] = useState(null);

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        const res = await axios.get(`${API}/builder/preview/${token}`);
        setSiteData(res.data);
      } catch {
        setError('هذا الرابط غير صالح أو انتهت صلاحيته');
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchPreview();
  }, [token]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-black" data-testid="preview-loading">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-orange-500 mx-auto mb-4" />
          <p className="text-white/60 text-sm font-medium" style={{ fontFamily: 'Tajawal, sans-serif' }}>جاري تحميل المعاينة...</p>
        </div>
      </div>
    );
  }

  if (error || !siteData) {
    return (
      <div className="h-screen flex items-center justify-center bg-black" dir="rtl" data-testid="preview-error">
        <div className="text-center max-w-sm px-6">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-red-500/10 flex items-center justify-center">
            <Eye className="w-7 h-7 text-red-400" />
          </div>
          <h2 className="text-white text-xl font-bold mb-2" style={{ fontFamily: 'Cairo, sans-serif' }}>المعاينة غير متوفرة</h2>
          <p className="text-white/50 text-sm" style={{ fontFamily: 'Tajawal, sans-serif' }}>{error || 'لم يتم العثور على الموقع'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col" data-testid="preview-page">
      {/* Preview Banner */}
      <div
        dir="rtl"
        className="flex items-center justify-center gap-3 py-2.5 px-4"
        style={{ background: 'linear-gradient(135deg, #D97706, #EA580C)', fontFamily: 'Tajawal, sans-serif' }}
        data-testid="preview-banner"
      >
        <Eye className="w-4 h-4 text-white/80" />
        <span className="text-white text-sm font-semibold">هذه معاينة حية — الموقع لم يُنشر بعد</span>
        {siteData.is_published && (
          <span className="text-white/70 text-xs px-2 py-0.5 rounded-full bg-white/15">منشور</span>
        )}
        <a
          href="/"
          className="mr-auto text-white/70 text-xs flex items-center gap-1 hover:text-white transition-colors"
        >
          <ExternalLink className="w-3 h-3" />
          ذوق AI
        </a>
      </div>

      {/* Site Preview */}
      <SitePreview
        config={siteData.config}
        menuItems={siteData.menu_items || []}
        className="flex-1"
      />
    </div>
  );
}
